import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export { _timeWindowDetailObj as TimeWindowDetailObj };
export { _atTimeWindowLimit as atTimeWindowLimit };
export { _setTimeWindowLimits as setTimeWindowLimits };
export { _updateTimeWindowDetails as updateTimeWindowDetails };
export { _getNextDayInTimeWindow as getNextDayInTimeWindow };

const _timeWindowDetailObj = function () {
  this.start = null;
  this.end = null;
  this.dateRangeStart = null;
  this.dateRangeFinish = null;
  this.currentPage = null;
  this.total = 0;
  this.count = 0;
  this.days = [];
};

const _atTimeWindowLimit = (timeWindowDetails) => {
  const daysDataFullyLoaded =
    timeWindowDetails.total === timeWindowDetails.count;
  const previousDay = dayjs(timeWindowDetails.end).utc().subtract(24, "hours");
  const limit = dayjs(timeWindowDetails.dateRangeStart).utc();
  const nextDayPastLimit = previousDay.isBefore(limit);
  return (
    (daysDataFullyLoaded && nextDayPastLimit) ||
    timeWindowDetails.days.length === 0
  );
};

const _getStartAndEndDate = (timeWindowDetails, date) => {
  timeWindowDetails.end = dayjs(date).utc().endOf("day");
  timeWindowDetails.start = dayjs(date).utc().startOf("day");
};

const _setTimeWindowLimits = (timeWindowDetails, params) => {
  timeWindowDetails.dateRangeFinish = params.dateRangeFinish || dayjs.utc();

  timeWindowDetails.dateRangeStart =
    params.dateRangeStart || timeWindowDetails.dateRangeFinish.clone();
  timeWindowDetails.dateRangeStart.subtract(
    params.limit.value,
    params.limit.type
  );
};

const _getNextDayInTimeWindow = (timeWindowDetails) => {
  const date = timeWindowDetails.days.shift();
  _getStartAndEndDate(timeWindowDetails, date);

  timeWindowDetails.total = 0;
  timeWindowDetails.count = 0;
  timeWindowDetails.currentPage = null;
};

const _updateTimeWindowDetails = (timeWindowDetails) => {
  if (timeWindowDetails.count >= timeWindowDetails.total) {
    _getNextDayInTimeWindow(timeWindowDetails);
  }
  if (timeWindowDetails.currentPage === null) {
    timeWindowDetails.currentPage = 0;
  } else {
    timeWindowDetails.currentPage += 1;
  }
};
